/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"

const AdminReports = (props) => {
  return (
    <BaseSvgIcon {...props} width="28px" height="33px" viewBox="0 0 28 33">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-187.000000, -1309.000000)" fill="#FFFFFF" fillRule="nonzero">
          <g transform="translate(150.000000, 1274.000000)">
            <path d="M59.5,37 L42.5,37 C41.6715729,37 41,37.6715729 41,38.5 L41,60.5 C41,61.3284271 41.6715729,62 42.5,62 L59.5,62 C60.3284271,62 61,61.3284271 61,60.5 L61,38.5 C61,37.6715729 60.3284271,37 59.5,37 Z M60,60.5 C60,60.7761424 59.7761424,61 59.5,61 L42.5,61 C42.2238576,61 42,60.7761424 42,60.5 L42,58 L43,58 L43,56 L42,56 L42,53 L43,53 L43,51 L42,51 L42,48 L43,48 L43,46 L42,46 L42,43 L43,43 L43,41 L42,41 L42,38.5 C42,38.2238576 42.2238576,38 42.5,38 L59.5,38 C59.7761424,38 60,38.2238576 60,38.5 L60,60.5 Z M57,49.5 C57,49.7761424 56.7761424,50 56.5,50 L46.5,50 C46.2238576,50 46,49.7761424 46,49.5 C46,49.2238576 46.2238576,49 46.5,49 L56.5,49 C56.7761424,49 57,49.2238576 57,49.5 Z M57,53.5 C57,53.7761424 56.7761424,54 56.5,54 L46.5,54 C46.2238576,54 46,53.7761424 46,53.5 C46,53.2238576 46.2238576,53 46.5,53 L56.5,53 C56.7761424,53 57,53.2238576 57,53.5 Z M56,41 L47,41 C46.4477153,41 46,41.4477153 46,42 L46,45 C46,45.5522847 46.4477153,46 47,46 L56,46 C56.5522847,46 57,45.5522847 57,45 L57,42 C57,41.4477153 56.5522847,41 56,41 Z M56,45 L47,45 L47,42 L56,42 L56,45 Z" />
          </g>
        </g>
      </g>
    </BaseSvgIcon>
  )
}

export default AdminReports
